import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  displayAboutDialog$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  displayAboutDialog(display: boolean) {
    this.displayAboutDialog$.next(display);
  }
}
